<div class="docEditor">
  <div class="w-100 header-container d-flex align-items-center justify-content-between docEditor__header">
    @if (selectedTemplateName) {
    <div>
      <span class="docEditor__header__title"> {{ 'docEditor.model' | translate }} </span>
      <p>{{ selectedTemplateName }}</p>
    </div>
    }
    @if (!selectedTemplateName) {
    <div>
      <span class="docEditor__header__title"> {{ 'docEditor.noModel' | translate }} </span>
    </div>
    }
    @if (documentSource === 'Web') {
    <div class="buttons__container d-flex align-items-center">
      @if (showDocExportBtn) {
      <i-button styleClass="blue me-2 text-center justify-content-center" [text]="'docEditor.export' | translate"
        [childrenItems]="exportBtnItems"></i-button>
      }
      @if (!(mailMode === 'emailnomodel' || mailMode === 'emailmodel')) {
      <i-button [text]="'docEditor.generateQR' | translate" [pTooltip]="'docEditor.insertQRCode' | translate"
        tooltipPosition="bottom" (click)="showQRModal()" styleClass="blue me-2"></i-button>
      }
      <i-button [text]="'docEditor.textLibraryShort' | translate" [pTooltip]="'docEditor.textLibrary' | translate"
        tooltipPosition="bottom" (click)="displayParagraphes = true; getParagraphes()"
        styleClass="blue me-2"></i-button>

      <i-button [text]="'back' | translate" (click)="cancel()" styleClass="red me-2"></i-button>
      @if (!(mailMode === 'emailnomodel' || mailMode === 'emailmodel')) {
      <i-button id="button-save" [text]="'docEditor.saveAndExit' | translate" (click)="prepareToSave()"
        styleClass="blue me-2"> </i-button>
      }
      @if (mailMode && (mailMode === 'emailnomodel' || mailMode === 'emailmodel')) {
      <i-button [text]="'docEditor.send' | translate" icon="fbi bi-envelope" styleClass="blue" (click)="submitEmail()">
      </i-button>
      }
    </div>
    }
    @if (documentSource === 'Externe') {
    <div class="buttons__container d-flex align-items-center">
      @if (showDocExportBtn) {
      <i-button styleClass="blue me-2 text-center justify-content-center" [text]="'docEditor.export' | translate"
        [childrenItems]="exportBtnItems"></i-button>
      }
      <i-button [text]="'docEditor.textLibraryShort' | translate" [pTooltip]="'docEditor.textLibrary' | translate"
        tooltipPosition="bottom" (click)="displayParagraphes = true; getParagraphes()"
        styleClass="blue me-2"></i-button>
      <i-button [text]="'back' | translate" (click)="cancel()" styleClass="red me-2"></i-button>
      @if (!(mailMode === 'emailnomodel' || mailMode === 'emailmodel')) {
      <i-button id="button-save" [text]="'docEditor.saveAndExit' | translate" (click)="prepareToSave(true)"
        styleClass="blue me-2"> </i-button>
      }
      @if (mailMode && (mailMode === 'emailnomodel' || mailMode === 'emailmodel')) {
      <i-button [text]="'docEditor.send' | translate" icon="bi bi-envelope" styleClass="blue" (click)="submitEmail()">
      </i-button>
      }
    </div>
    }
  </div>
  @if (documentSource === 'Externe') {
  <div class="row mt-4">
    <div class="col-md-6 mb-3">
      <div class="square h-100" (click)="showPDF()">
        <i class="bi--big_icon bi bi-filetype-pdf icon me-0"></i>
        <p class="answerTitle">{{ 'docEditor.previewPDF' | translate }}</p>
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="square h-100" (click)="downloadFile()">
        <i class="bi bi-download icon me-0"></i>
        <p class="answerTitle">{{ 'docEditor.downloadFile' | translate }}</p>
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="square">
        <p-fileUpload #fileUpload [auto]="true" styleClass="file-upload-simple" customUpload="true"
          (uploadHandler)="onUpload($event)" multiple="false" accept=".rtf" maxFileSize="1000000"
          [showCancelButton]="false" [chooseLabel]="'docEditor.selectFile' | translate"
          [uploadLabel]="'docEditor.uploadRTF' | translate">
        </p-fileUpload>
        <p class="answerTitle">{{ 'docEditor.uploadFile' | translate }}</p>
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="square h-100" (click)="displayParagraphes = true; getParagraphes()">
        <i class="bi bi-text-paragraph icon me-0"></i>
        <p class="answerTitle">{{ 'docEditor.textLibrary' | translate }}</p>
      </div>
    </div>
  </div>
  }
  <div class="editor-container mt-2">
    @if ((mailMode === 'emailnomodel' || mailMode === 'emailmodel') && documentSource === 'Web') {
    <div [formGroup]="emailForm" (ngSubmit)="submitEmail()">
      <div class="emailTips">
        <div class="row">
          <div class="col-12">
            <p class="tips">{{ 'docEditor.addContactNotInList' | translate }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-2">
            @if (notEmailList !== '') {
            <div class="alert alert-danger" role="alert">
              {{ 'docEditor.followingRecipients' | translate }} <span class="notEmail">{{ notEmailList }}</span>
              {{ 'docEditor.noPrimaryEmailAddress' | translate }}
            </div>
            }
          </div>
        </div>
      </div>
      <div class="emailHeader row">
        <div class="col-md-12 p-fluid">
          <h4 class="custom-h4-title">{{ 'docEditor.to' | translate }}*</h4>
          <p-chips styleClass="w-100" [allowDuplicate]="false" [addOnTab]="true" [addOnBlur]="true"
            formControlName="recipients" separator="," field="email" (onAdd)="onAddRecipient($event)"
            (onRemove)="onRemoveRecipient($event)"></p-chips>
        </div>
        <div class="col-md-6 p-fluid">
          <h4 class="custom-h4-title">{{ 'docEditor.cc' | translate }}</h4>
          <p-chips styleClass="w-100" [allowDuplicate]="false" [addOnTab]="true" [addOnBlur]="true" formControlName="cc"
            separator=","> </p-chips>
        </div>
        <div class="col-md-6 p-fluid">
          <h4 class="custom-h4-title">{{ 'docEditor.bcc' | translate }}</h4>
          <p-chips styleClass="w-100" [allowDuplicate]="false" [addOnTab]="true" [addOnBlur]="true"
            formControlName="bcc" separator=","> </p-chips>
        </div>
        <div class="col-md-6 p-fluid mb-3">
          <h4 class="custom-h4-title">{{ 'docEditor.subject' | translate }}*</h4>
          <i-input [iInput]="{ placeholder: '' }" [type]="'text'" [control]="emailForm.get('subject')"
            [showError]="false" styleClass="d-block w-100"></i-input>
        </div>
        <div class="col-md-6 p-fluid mb-3">
          <h4 class="custom-h4-title">
            {{ 'docEditor.attachedFiles' | translate }}
            <span (click)="openFilesModal()"><i class="bi bi-paperclip iconFile"></i></span>
          </h4>
          <p-chips inputStyleClass="w-100" styleClass="w-100" [allowDuplicate]="false" formControlName="files"
            field="name" [max]="mailFiles.length">
          </p-chips>
        </div>
      </div>
    </div>
    }
    <div class="myEditor" [ngClass]="{ 'd-none': documentSource !== 'Web' }">
      <div class="myEditor" cdkDropList #selectedPic="cdkDropList" [cdkDropListConnectedTo]="[selectedPic]"
        (cdkDropListDropped)="dropped($event)" [ngClass]="{ 'd-none': documentSource !== 'Web' }">
        @if (documentSource === 'Web') {
        <i-richedit #document_editor [showMergeFields]="true" [lang]="lang" [mergeFields]="mergeFields()"></i-richedit>
        }
      </div>
      @if (documentSource === 'Web') {
      <div className="overlay" id="popup-overlay" style="display: none"></div>
      }
      @if (documentSource === 'Web') {
      <div id="waiting-popup" style="display: none">
        <svg className="circular" height="40" width="40">
          <circle className="circle-path" cx="25" cy="25" r="20" fill="none" strokeWidth="6" strokeMiterlimit="10" />
        </svg>
      </div>
      }
    </div>
  </div>

  <p-sidebar position="right" [(visible)]="displayParagraphes" styleClass="ui-sidebar-sm" [modal]="false">
    <div class="ms-1 me-1">
      <i-title [text]="'docEditor.textLibrary' | translate"></i-title>
      <input type="text" class="form-control w-100 mt-3 mb-3" [(ngModel)]="searchValueBibli" />
    </div>
    <i-accordion [hideShowAllBtn]="true">
      @for (item of paragraphes | keyvalue; track item; let i = $index) {
      <i-accordion-tab [showEditBtn]="false" header="{{ item.key }}" class="box" cdkDropList [attr.id]="'todoList' + i"
        [cdkDropListData]="item.value" [cdkDropListConnectedTo]="[selectedPic]">
        <div class="mergeFields">
          @for (text of item.value | sort: 'description' : 'ASC' | searchByKey: 'description' : searchValueBibli; track
          text) {
          <div class="cell" (click)="copy($event, text)" (dblclick)="insertParagraphes(text)"
            [cdkDragData]="text.texteRtf" cdkDrag>
            <div [pTooltip]="text.texte"><i class="bi bi-copy me-1"></i>{{ text.description }}</div>
          </div>
          }
        </div>
      </i-accordion-tab>
      }
    </i-accordion>
  </p-sidebar>

  <p-sidebar position="right" [(visible)]="displayFusion" styleClass="ui-sidebar-sm" [modal]="false"
    [dismissible]="false">
    <div class="ms-1 me-1">
      <i-title [text]="'docEditor.mergeFields' | translate"></i-title>
      <input type="text" class="form-control w-100 mt-3 mb-3" [(ngModel)]="searchValue" />
    </div>
    <i-accordion [hideShowAllBtn]="true">
      @for (item of fusions | keyvalue; track item; let i = $index) {
      <i-accordion-tab [showEditBtn]="false" header="{{ item.key }}" class="box">
        <div class="mergeFields" cdkDropList #todoList="cdkDropList" [cdkDropListData]="item.value"
          [cdkDropListConnectedTo]="[selectedPic]">
          @for (text of item.value | sort: 'description' : 'ASC' | searchByKey: 'key' : searchValue; track text) {
          <div class="cell" (click)="copy($event, text)" (dblclick)="insert(text.key)" [cdkDragData]="text.key" cdkDrag>
            <div [pTooltip]="text.description ? text.description : text.key"><i class="bi bi-copy me-1"></i>{{
              text.description }}</div>
          </div>
          }
        </div>
      </i-accordion-tab>
      }
    </i-accordion>
  </p-sidebar>

  <p-dialog styleClass="super-compos-modal-content modal-scss" [(visible)]="showQuestion" [modal]="true"
    [style]="{ width: '50vw' }" [closable]="true">
    <p-header>
      <div class="d-flex align-items-center justify-content-between">
        <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'docEditor.validationSignatureQuestions' |
          translate }}</h5>
      </div>
    </p-header>
    <div class="row" [formGroup]="questionForm" #questionModal>
      <div formArrayName="ProcedureValidationQuestionPosees" class="col-md-12">
        @for (question of procedureValidationQuestionPosees.controls; track question; let i = $index) {
        <div class="mb-3">
          <div [formGroupName]="i">
            <label class="super-compos-label-input">{{ question.get('questionPosee').value }}</label>
            <div class="row">
              <div class="col-md-6 p-fluid">
                <label class="super-compos-label-input">{{ 'docEditor.role' | translate }}</label>
                <p-dropdown [options]="roles" [filter]="true" [showClear]="true" formControlName="roleId"
                  [disabled]="true" appendTo="body"></p-dropdown>
              </div>
              <div class="col-md-6 p-fluid">
                <label class="super-compos-label-input">{{ 'docEditor.service' | translate }}*</label>
                <p-treeSelect [propagateSelectionUp]="false" [propagateSelectionDown]="true"
                  [emptyMessage]="'noResultFound' | translate" [options]="serviceParent" #treeSelect
                  [id]="'treeSelect' + i" selectionMode="single" [placeholder]="'pleaseSelectAService' | translate"
                  appendTo="body" formControlName="serviceId" [class]="'treeSelect' + i" [filter]="true"
                  [filterPlaceholder]="'global.filterPlaceholder' | translate" [filterBy]="'label'"
                  [filterMode]="'strict'" [metaKeySelection]="false">
                </p-treeSelect>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    <i-button styleClass="bottomButton red mb-3" (click)="cancelQuestion()" [text]="'cancel' | translate"></i-button>
    <i-button styleClass="bottomButton green" (click)="submit()" [text]="'confirm' | translate"></i-button>
  </p-dialog>
  <p-confirmDialog #cd appendTo="body" styleClass="super-compos-modal-content confirmModal" header="Confirmation"
    icon="bi bi-exclamation-triangle">
    <p-footer>
      <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
      <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate"
        (click)="cd.accept()"></button>
    </p-footer>
  </p-confirmDialog>
</div>